const CREATE = 'CREATE';
const CREATEORUPDATE = 'CREATEORUPDATE';
const UPDATEONLYFIELDS = 'UPDATEONLYFIELDS';

export const ImportTypes = {
  CREATE,
  CREATEORUPDATE,
  UPDATEONLYFIELDS,
};
